/**
 * Directive for generate filter fields.
 *
 * @class generateFilterFields
 * @memberof mwApp/reports
 * @see mwApp/reports
 *
 * @ngdoc directive
 * @name mwApp/reports:generateFilterFields
 *
 * @example
 * <generate-filter-fields ng-repeat="filter in vm.report.filterList" filter-data="filter"></generate-filter-fields>
 */
/* @ngInject */
export function generateFilterFields ($compile, $timeout) {
  const getTemplate = function (scope, contentType) {
    /* eslint-disable max-len */
    const templateMap = {
      SUBSCRIBER_STATUS:
                `
                <div class="form-group">
                    
                    <div class="col-xs-4">
                        <div class="modded">
                            <select class="form-control" name="{{filter.reportElementType}}" name="{{filter.reportElementType}}" ng-model="filter.status"
                            ng-init="filter.status = filter.status || filterState.abstractFilterValues[0]" ng-focus="vm.setFocus(filter.reportElementType)">
                                <option ng-repeat="(key, value) in filterState.abstractFilterValues"
                                    value="{{value}}">{{vm.statuses[value]}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-3 nopadding">
                        <div class="checkbox checkbox-primary">
                            <input id="disableStatusRange" type="checkbox" ng-model="filter.$disableStatusRange" class="ng-pristine ng-valid ng-not-empty ng-touched">
                            <label for="disableStatusRange">
                                Disable range.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="pl-15">
                    <label class="col-xs-1 control-label">&nbsp;</label>
                    <div class="calendarstyle col-xs-10">
                    <div class="form-group ">
                        <label class="col-xs-1 control-label">From:</label>
                        <div class="col-xs-4">
                            <div class="input-group">
                            <input type="text" class="form-control" ng-model="filter.$fromDate" ng-disabled="filter.$disableStatusRange" name="{{filter.reportElementType}}_from" ng-focus="vm.setFocus(filter.reportElementType + '_from')"
                                ng-model-options="{allowInvalid:false}" uib-datepicker-popup="dd.MM.yyyy" is-open="opened.after" close-text="Close" ng-change="changeFrom()" datepicker-options="optionsFrom" />
                                <div class="input-group-btn">
                                    <button type="button" class="btn btn-default btn-half" ng-click="open('after')">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <label class="col-xs-1 control-label">To:</label>
                        <div class="col-xs-4">
                            <div class="input-group">
                            <input type="text" class="form-control" ng-model="filter.$toDate" ng-disabled="filter.$disableStatusRange" name="{{filter.reportElementType}}_to" ng-focus="vm.setFocus(filter.reportElementType + '_to')"
                                ng-model-options="{allowInvalid:false}" uib-datepicker-popup="dd.MM.yyyy" is-open="opened.before" close-text="Close" ng-change="changeTo()" datepicker-options="optionsTo" />
                                <div class="input-group-btn">
                                    <button type="button" class="btn btn-default btn-half" ng-click="open('before')">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                `,

      SUBSCRIBER_AUTO_PAY:
                `<div class="col-xs-4">
                    <div class="modded">
                        <select class="form-control" name="{{filter.reportElementType}}" name="{{filter.reportElementType}}" ng-focus="vm.setFocus(filter.reportElementType)"
                            ng-model="filter.status" ng-init="filter.status = filter.status || filterState.abstractFilterValues[0]">
                            <option ng-repeat="(key, value) in filterState.abstractFilterValues"
                                value="{{value}}">{{value}}</option>
                        </select>
                    </div>
                </div>`,

      SUBSCRIBER_ENABLED:
        `<div class="col-xs-4">
                    <div class="modded">
                        <select class="form-control" name="{{filter.reportElementType}}" name="{{filter.reportElementType}}" ng-focus="vm.setFocus(filter.reportElementType)"
                            ng-model="filter.status" ng-init="filter.status = filter.status || filterState.abstractFilterValues[0]">
                            <option ng-repeat="(key, value) in filterState.abstractFilterValues"
                                value="{{value}}">{{value}}</option>
                        </select>
                    </div>
                </div>`,

      SUBSCRIBER_NEW_SUBSCRIBERS_DAYS:
                `<div class="col-xs-4">
                    <input type="number" name="{{filter.reportElementType}}" min="0"
                        class="form-control" required="required" autocomplete="off" ng-model="filter.days" ng-focus="vm.setFocus(filter.reportElementType)">
                </div>`,

      SUBSCRIBER_NEW_SUBSCRIBERS_DATE_FROM_TO:
                `<div class="calendarstyle col-xs-9">
                    <div class="form-group row">
                        <label class="col-xs-1 control-label">From:</label>
                        <div class="col-xs-5">
                            <div class="input-group">
                            <input type="text" class="form-control" ng-model="filter.$fromDate" name="{{filter.reportElementType}}_from" ng-focus="vm.setFocus(filter.reportElementType + '_from')"
                                ng-model-options="{allowInvalid:false}" uib-datepicker-popup="dd.MM.yyyy" is-open="opened.after" close-text="Close" ng-change="changeFrom()" datepicker-options="optionsFrom"/>
                                <div class="input-group-btn">
                                    <button type="button" class="btn btn-default btn-half" ng-click="open('after')">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <label class="col-xs-1 control-label">To:</label>
                        <div class="col-xs-5">
                            <div class="input-group">
                            <input type="text" class="form-control" ng-model="filter.$toDate" name="{{filter.reportElementType}}_to" ng-focus="vm.setFocus(filter.reportElementType + '_to')"
                                ng-model-options="{allowInvalid:false}" uib-datepicker-popup="dd.MM.yyyy" is-open="opened.before" close-text="Close" ng-change="changeTo()" datepicker-options="optionsTo"/>
                                <div class="input-group-btn">
                                    <button type="button" class="btn btn-default btn-half" ng-click="open('before')">
                                        <i class="glyphicon glyphicon-calendar"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`
    }
    /* eslint-enable max-len */

    return (
      !scope.canNotBeDeleted
        ? `<div class="pull-left pl-15 add-filter">
              <a href="#">
                  <i class="fa fa-minus-square"></i>
              </a>
          </div>` : ''
    ) + templateMap[contentType]
  }

  const linker = function (scope, element) {
    const to = new Date(scope.filter.$toDate)
    const from = new Date(scope.filter.$fromDate)

    /* Initialize params for datepickers. */
    scope.value = { after: null, before: null }
    scope.opened = { after: false, before: false }
    scope.open = w => { scope.opened[w] = true }

    scope.optionsFrom = {
      maxDate: new Date(to.setDate(to.getDate()))
    }
    scope.optionsTo = {
      minDate: new Date(from.setDate(from.getDate()))
    }
    scope.changeFrom = function () {
      let fromActual = new Date(scope.filter.$fromDate)
      let toActual = new Date(scope.filter.$toDate)

      if (fromActual.setHours(0, 0, 0, 0) > toActual.setHours(0, 0, 0, 0)) {
        scope.filter.$fromDate = new Date(toActual.setDate(toActual.getDate() - 1))

        fromActual = angular.copy(scope.filter.$fromDate)
        toActual = angular.copy(scope.filter.$toDate)
      }

      scope.optionsFrom.maxDate = new Date(toActual.setDate(toActual.getDate()))
      scope.optionsTo.minDate = new Date(fromActual.setDate(fromActual.getDate()))
    }
    scope.changeTo = function () {
      let fromActual = new Date(scope.filter.$fromDate)
      let toActual = new Date(scope.filter.$toDate)

      if (fromActual.setHours(0, 0, 0, 0) > toActual.setHours(0, 0, 0, 0)) {
        scope.filter.$toDate = new Date(fromActual.setDate(fromActual.getDate() + 1))

        fromActual = angular.copy(scope.filter.$fromDate)
        toActual = angular.copy(scope.filter.$toDate)
      }

      scope.optionsFrom.maxDate = new Date(toActual.setDate(toActual.getDate()))
      scope.optionsTo.minDate = new Date(fromActual.setDate(fromActual.getDate()))
    }

    /* Options for current filter. */
    scope.filterState = scope.vm.generateFilterState(scope.filter.reportElementType)

    const template = getTemplate(scope, scope.filter.reportElementType)
    const compiledTemplate = $compile(template)(scope)

    compiledTemplate.find('a').on('click', function () {
      scope.vm.removeFilter(scope.filter.reportElementType)

      scope.$apply()
    })

    element.find('span').replaceWith(compiledTemplate)

    $timeout(function () {
      const focusedElement = element[0].querySelector(`[name="${scope.vm.focusedElementName}"]`)

      if (focusedElement) {
        focusedElement.focus()
      }
    })
  }

  return {
    restrict: 'E',
    replace: true,
    scope: false,
    template:
            `<div class="form-group" style="transition: height 1s ease-in-out;">
                <label class="col-xs-2 control-label" >{{vm.filterNames[filter.reportElementType]}}:</label>
                <span></span>
            </div>`,
    link: linker
  }
}
